import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('inventorySupplierStore')
@observer
class InventorySupplierModify extends Component {
  render() {
    const { inventorySupplierStore, params} = this.props;
    return (
      <ItemModify
      title = 'Inventory Supplier'
      slug = '/inventory/supplier'
      store = {inventorySupplierStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Address', key: 'address', type: 'text' },
        { label: 'Contact Person', key: 'contact_person', type: 'text' },
        { label: 'Phone Number', key: 'phone_number', type: 'text' },
        { label: 'Email', key: 'email', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default InventorySupplierModify;



// WEBPACK FOOTER //
// ./src/components/Inventory/SupplierModify.js